<template>
    <v-app>
        <v-main>
            <v-container v-if="!loading">
                <div style="display: flex; flex-direction: row; align-items:center;">
                    <div><h1>MyVilla Statistics</h1></div>
                    <v-spacer></v-spacer>
                    <div style="padding-top: 20px; margin-right: 30px; width: 150px;">
                        <v-select v-model="referenceDate" :items="dateOptions" label="Reference Date" dense @change="getStats()"/>
                    </div>  
                    <div style="margin-right: 30px;">
                        <v-btn class="ml-2" color="primary" @click="getStats()" :loading="loading" :disabled="loading">
                            <v-icon class="mr-2">mdi-refresh</v-icon>Refresh data
                        </v-btn>
                    </div>                
                </div>
                <div class="mb-2">
                    <div style="display: flex; flex-direction: row; align-items: center;">
                        <div style="width: 80px;"><strong>Date:</strong></div>
                        <div>{{ $moment(referenceDate).format('dddd, D MMMM YYYY') }} (Week {{ $moment(referenceDate).week() }})</div>
                    </div>
                    <div style="display: flex; flex-direction: row; align-items: center;">
                        <div style="width: 80px;"><strong>Calls:</strong></div>
                        <div>{{ totalCalls }}</div>                    
                    </div>                      
                    <div style="display: flex; flex-direction: row; align-items: center;">
                        <div style="width: 80px;"><strong>Users:</strong></div>
                        <div>{{ totalUsers }}</div>                    
                    </div>                      
                </div>
                <v-data-table :headers="getHeaders()" :items="data" dense :items-per-page="-1" hide-default-footer>
                    <template v-slot:item="call">
                        <tr>
                            <td>{{ call.item.procname }}</td>
                            <td align="end">{{ call.item.proccalls }}</td>
                            <td align="end">{{ call.item.proctotal }}</td>
                            <td align="end">{{ call.item.procavg }}</td>
                            <td align="end">{{ call.item.procmin }}</td>
                            <td align="end">{{ call.item.procmax }}</td>
                        </tr>
                    </template>
                </v-data-table> 
                <div class="pa-4"></div>     
                <v-data-table :headers="getHeadersEign()" :items="eigndata" dense :items-per-page="-1" hide-default-footer>
                    <template v-slot:item="call">
                        <tr>
                            <td>{{ call.item.eigncode }}</td>
                            <td>{{ call.item.eignnaam }}</td>
                            <td align="end">{{ call.item.eigncount }}</td>
                            <td align="end">{{ call.item.firstcall }}</td>
                            <td align="end">{{ call.item.lastcall }}</td>
                        </tr>
                    </template>
                </v-data-table>       
            </v-container>
        </v-main>
        <navBar title="Ares - Reference data" :home="true" type="referencedata"/> 
    </v-app>
</template>
<script>
    import navBar from "@/components/ui/navbars/navbar.vue";

    export default {
        components: {
            navBar
        },
        data() { 
            // Helper functions
            const pad = n => n < 10 ? '0' + n : n;
            const toISO = d => d.toISOString().split('T')[0];
            const toDDMMYYYY = d => `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}`;
            // Build dateOptions: today and 7 days back
            let dateOptions = [];
            const first = new Date("2025-06-23T00:00:00");
            for (let d = new Date(); d > first; d.setDate(d.getDate() - 1)) {
                dateOptions.push({
                    text: toDDMMYYYY(d),
                    value: toISO(d)
                });
            }      
            return {
                data: [],
                eigndata: [],
                loading: true,
                referenceDate: toISO(new Date()),
                dateOptions,            
            }
        },
        computed: {
            totalCalls() {
                let total = 0;
                for (let iIndex=0; iIndex<this.data.length; iIndex++) {
                    total = total + this.data[iIndex].proccalls;
                }
                return total
            },
            totalUsers() {
                return this.eigndata.length;
            }
        },
        async mounted() {
            console.log("test " +this.referenceDate);
            this.getStats();
        },    
        methods: {
            isEmpty(obj) {
                return Object.keys(obj).length === 0
            },
            getHeaders() {
                return [
                    { text: "Program", value: "procname" },
                    { text: "Calls", value: "proccalls", align: "end", width: "10%" },
                    { text: "Execution (ms)", value: "proctotal", align: "end", width: "10%" },
                    { text: "Avg Execution (ms)", value: "procavg", align: "end", width: "10%" },
                    { text: "Fastest (ms)", value: "procmin", align: "end", width: "10%" },
                    { text: "Slowest (ms)", value: "procmax", align: "end", width: "10%" },
                ]
            },
            getHeadersEign() {
                return [
                    { text: "Host", value: "eigncode", width: "5%" },
                    { text: "Host naam", value: "eignnaam" },
                    { text: "Calls", value: "eigncount", align: "end", width: "10%" },
                    { text: "First call", value: "firstcall", align: "end", width: "10%" },
                    { text: "Last call", value: "lastcall", align: "end", width: "10%" },
                ]
            },
            getStats() {
                this.getStatsLogs();
            },
            getStatsLive() {
                // this.getStats2();
                this.loading=true
                this.$axios.post("ares/json/ares/syst/misc/getStatisticsMV.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getStatistics"
                    },
                    getStatistics: {
                        referenceDate: this.referenceDate,
                    }
                }).then(res => {
                    this.loading = false
                    this.data = res.data
                    // console.log(this.data)
                });         
            },
            getStatsLogs() {
                this.loading=true
                this.$axios.post("ares/json/ares/syst/misc/getStatisticsLogMV.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getStatisticsLogMV"
                    },
                    getStatisticsLogMV: {
                        date_from: this.referenceDate,
                        date_to: this.referenceDate,
                    }
                }).then(res => {
                    this.loading = false
                    this.data = res.data.stats;
                    this.eigndata = res.data.eigns;
                    //console.log(this.data)
                });         
            }
        }          
    }
</script>    
<style scoped>

</style>